import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PoModule } from '@po-ui/ng-components';
import { PoPageDynamicEditModule, PoPageDynamicTableModule } from '@po-ui/ng-templates';
import { ReactiveFormsModule } from '@angular/forms';
import { ReportsComponent } from './reports.component';

@NgModule({
    declarations: [ReportsComponent],
    exports: [ReportsComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        PoModule,
        PoPageDynamicTableModule,
        PoPageDynamicEditModule
    ]
})
export class ReportsModule { }
